module.exports = __webpack_public_path__ + "img/Layer 4.8100ab1a.svg";